import { Injectable } from '@angular/core';
import { SiteUser, UserLogo, UserResponse } from '../../../model/user';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export abstract class UserService {

  abstract getUsers(): Observable<SiteUser[]>;

  abstract getUserLogos(): Observable<UserLogo[]>;

  abstract saveUserLogo(userId: number, logoId: number);

}
